import { buildInFilter, type GridFilters } from '@/ui/composites/grid/gridFilters';

export const buildPipelineEntityFilters = (pipelineIds: string[]): GridFilters =>
  buildInFilter('id', pipelineIds);

export const buildBuildPipelineFilters = (pipelineIds: string[]): GridFilters =>
  buildInFilter('pipelineId', pipelineIds);
